import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DeliveryCost, NewDeliveryCost } from "src/app/domain/models/DeliveryCost";

@Injectable({providedIn: 'root'})
export abstract class DeliveryCostGateway {
  abstract create(deliveryCost: NewDeliveryCost): Observable<DeliveryCost>
  abstract update(deliveryCost: DeliveryCost): Observable<DeliveryCost>
  abstract delete(id: number): Observable<any>
  abstract getAllByImportOrderId(importOrderId: any): Observable<DeliveryCost[]>
}
